import React, { useMemo, useEffect, useCallback } from "react";
import { compose, branch, renderComponent } from "recompose";
import { connect } from "react-redux";
import { getCurrentDealer, actions } from "../../modules/dealers";
import DealerList from "../../components/DealerList";
import { getUser } from "../../modules/auth";
import _ from "lodash";
import Button from "../../components/CustomButton";

const hasNoDealer = ({ currentDealer }) => !currentDealer;

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

const getDealersByRole = (user, role) =>
  _.map(_.get(user, role, []), s => s.dealer);

const getDealersByContact = (user) =>
  user.dealer_for_contact;

const CurrentDealerAdvice = ({ user, role, setCurrentDealer }) => {
  const dealers = useMemo(() => {
    return role === "customer"
      ? getDealersByRole(user, "customers")
      : (role === "contact" ? getDealersByContact(user) : getDealersByRole(user, "staff"));
  }, [user, role]);

  useEffect(() => {
    if (dealers.length === 1 && role) {
      setCurrentDealer(dealers[0]);
    }
  }, [dealers, setCurrentDealer, role]);

  const onClickSelectDealer = useCallback(
    dealer => () => {
      setCurrentDealer(dealer);
    },
    [setCurrentDealer]
  );
  return (
    <div>
      <h4 className="title content">Select a dealer to work with</h4>
      <DealerList dealers={dealers}>
        {({ dealer }) => (
          <Button color="primary" onClick={onClickSelectDealer(dealer)}>
            Select
          </Button>
        )}
      </DealerList>
    </div>
  );
};

export const withCurrentDealer = nonOptimalStates([
  { when: hasNoDealer, render: renderComponent(CurrentDealerAdvice) }
]);

export default compose(
  connect(
    state => ({
      currentDealer: getCurrentDealer(state),
      user: getUser(state),
      role: state.settings.role
    }),
    {
      setCurrentDealer: actions.setCurrentDealer
    }
  ),
  withCurrentDealer
);
